/*
 * КАРКАС, В КОТОРОМ РАБОЧАЯ ОБЛАСТЬ ВЫЖИВАЕТ.
 *
 * Правило одно и держится тремя строчками: у оболочки фиксированная высота экрана,
 * у каждой полосы flex: none, а у рабочей области — flex: 1 и min-height: 0.
 * Без min-height: 0 содержимое с собственной прокруткой (сетка журнала) растягивает
 * колонку изнутри, и полосы уезжают за край экрана вместе с шапкой.
 *
 * Потолок самих полос задан в service-stripes.module.css: три полосы разом съедают 90 px,
 * а с полосой часового пояса — 120, и это надо было проверить, а не понадеяться.
 */

.shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: var(--bg-workspace);
}

.body {
  display: flex;
  flex: 1;
  min-height: 0;
}

.main {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}

.content {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

/*
 * Телефон мастера. Переключатель филиала стоит отдельной строкой под шапкой: в шапке
 * на 360 точках он либо оттеснит заголовок, либо обрежется до многоточия — а филиал
 * обрезать нельзя, это то самое место, где путают город.
 */
.phoneBranch {
  display: flex;
  flex: none;
  padding: var(--space-2) var(--space-4);
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
}
